import type { SubmissionFilters } from "@/api/survey-library.service";
import type { ApiError, StatusChipColor } from "./surveyDetails.types";

export const DUPLICATE_SURVEY_CONFLICT_MESSAGE =
  "A survey for this edition and publication already exists.";

/** Another survey already uses this edition + publication pair. */
export function isSurveyEditionPublicationTakenConflict(error: ApiError): boolean {
  if (error.status !== 409) {
    return false;
  }
  const msg = error.message ?? "";
  return msg.includes("already exists") && msg.includes("edition");
}

export const STATUS_CHIP_COLOR: StatusChipColor = {
  published: "success",
  draft: "default",
};

export const TYPES_WITH_CHOICES = new Set(["dropdown", "radiogroup", "checkbox"]);

export const DEFAULT_HEADER_TAG = "h3";

export const HEADER_TAG_OPTIONS = [
  { value: "h1", label: "H1" },
  { value: "h2", label: "H2" },
  { value: "h3", label: "H3" },
];

export const FILTER_KEY_LABELS: Record<string, string> = {
  refereeBusinessType: "Business Type",
  submissionType: "Submission",
  refereeType: "Referee",
  region: "Region",
  practiceGroup: "Practice Group",
  practiceArea: "Practice Area",
};

export const TRANSLATION_SOURCE_LANGUAGE = "en";
export const FALLBACK_TRANSLATION_LANGUAGES = ["de", "fr", "es", "pl", "pt", "zh", "it", "nl"];

export const LANGUAGE_LABEL_MAP: Record<string, string> = {
  en: "English",
  de: "German",
  fr: "French",
  es: "Spanish",
  pl: "Polish",
  zh: "Mandarin",
  pt: "Portuguese",
  it: "Italian",
  nl: "Dutch",
};

export const TESTIMONIAL_REQUIRED_MESSAGE =
  "Add at least one Testimonial or Multi Testimonial question before saving or publishing.";

export const PUBLICATION_LOCKED_BY_TAXONOMY_RULES_MESSAGE =
  "Publication cannot be changed while display rules include Region, Practice Group, or Practice Area for the current publication. Remove those rules first.";

export const EDITION_LOCKED_BY_TAXONOMY_RULES_MESSAGE =
  "Edition cannot be changed while display rules include Region, Practice Group, or Practice Area for the current publication. Remove those rules first.";

export type RuleValueLabelMaps = Partial<Record<keyof SubmissionFilters, Map<string, string>>>;

export const AUTO_TRANSLATE_BATCH_SIZE = 100;
export const AUTO_TRANSLATE_BATCH_MAX_CHARS = 20_000;
export const AUTO_TRANSLATE_CONCURRENCY = 3;
